/*
 * @Author: zxl
 * @Date: 2021-06-08 18:09:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-09 13:58:25
 * @Description: 描述
 * @FilePath: \XBAdmine:\qqjieshou\XBAdminVUE\src\views\Set\Filiale\api\service.js
 */

import axios from '../../../../utils/request';
function GET_DATA(params) {
    return axios.get("/customer/AServiceType/index",{
        params: {
            page:params
        }
    } )
}

function CHANG_STATUS_FILALE(params) {
    return  axios.post("/customer/AServiceType/statusEdit",{
        status: {
            ...params
        }
    } )
}
function LIST_ORDER(params) {
    return axios.post("/customer/AServiceType/listOrder", {list_orders: params})
}
function OPEN_EDIT(params) {
    return  axios.get("/customer/AServiceType/edit",{
        params: {
            id:params
        }
    } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/customer/AServiceType/editPost",{...params} )
}
export default {
    GET_DATA, LIST_ORDER,CHANG_STATUS_FILALE,OPEN_EDIT,SUBMIT_EDIT
};
